import React from 'react'

const GoBack: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">
		<rect width="40" height="40" fill="#F7F8FA" rx="20"></rect>
		<path fill="#3D3C3C" fillOpacity="0.7" d="M28 19H15.83l5.59-5.59L20 12l-8 8 8 8 1.41-1.41L15.83 21H28v-2z"></path>
	</svg>
)

export default GoBack
